import React, { Component } from "react";
import { Card, Button, Tooltip, OverlayTrigger, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import DateRangeAndAmount from "../DateRangeAndAmount/DateRangeAndAmount";
import { tableHeightScrollBars, findBySearch, utcToSpecificTimeZone, scroolToTop } from "../helper";
import moment from "moment";
import { VirtualTerminalActions } from "../../Actions";
import { saveAs } from "file-saver";

class VtermTransaction extends Component {
    // NMI result_code 100 = approved (aligns with permit transaction pattern)
    isApproved = (row) => +row?.result_code === 100;

    // Only filter after Search button is clicked
    getFilteredTransactions = () => {
      // Use filtered list from state
      return this.state.filteredTransactionsList || this.state.vtermTransactionsList;
    };
  constructor(props) {
    super(props);
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.state = {
      loader: false,
      searchValue: "",
      count: 0,
      vtermTransactionsList: [],
      filteredTransactionsList: [],
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      currentSummaryDate: null,
      finalTableHeight: 0,
      daysDifference: 30,
      filterStatus: "",
      pendingFilterStatus: "",
      startDateTime: "",
      endDateTime: "",
      searchedtransactionsList: [],
    };
    this.customStyles = {
      rows: { style: { minHeight: "72px" } },
      headCells: { style: { paddingLeft: "8px", paddingRight: "8px" } },
      cells: { style: { paddingLeft: "8px", paddingRight: "8px" } },
    };
    this.columns = [
      {
        name: "Transaction Time",
        width: "160px",
        sortable: true,
        cell: (row) => this.showTransactionTime(row),
        selector: (row) => row.transaction_time,
      },
      {
        name: "Transaction Id",
        width: "130px",
        sortable: true,
        cell: (row) => this.showTransactionIdField(row),
        selector: (row) => row?.transaction_id,
      },
      {
        name: "Product",
        width: "220px",
        sortable: true,
        cell: (row) => this.showProductField(row),
        selector: (row) => row?.name,
      },
      {
        name: "Quantity",
        width: "90px",
        sortable: true,
        cell: (row) => this.showQuantityField(row),
        selector: (row) => row?.quantity || 1,
      },
      {
        name: "Unit",
        width: "120px",
        sortable: true,
        cell: (row) => this.showUnitField(row),
        selector: (row) => row?.unit_id || row?.suite_id,
      },
      {
        name: "Payment Status",
        width: "140px",
        sortable: true,
        cell: (row) => this.getSuccessFailedData(row),
        selector: (row) => row.payment_status,
      },
      {
        name: "Card Number",
        width: "120px",
        sortable: true,
        cell: (row) => this.showCardNumberField(row),
        selector: (row) => row?.card,
      },
      {
        name: "Amount",
        width: "100px",
        sortable: true,
        cell: (row) => this.showAmountField(row),
        selector: (row) => row.amount,
      },
      {
        name: "Type",
        width: "120px",
        sortable: true,
        cell: (row) => this.showTypeField(row),
        selector: (row) => row?.type,
      },
      {
        name: "Status",
        width: "120px",
        sortable: true,
        cell: (row) => this.getStatusData(row),
        selector: (row) => row?.status,
      },
      {
        name: "Message Response",
        sortable: true,
        grow: 1,
        cell: (row) => this.showMessageResponseField(row),
        selector: (row) => row.payment_status,
      },
    ];
    }
    // Show Unit field (unit_id or suite_id)
    showUnitField = (row) => (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-unit`}>{row?.unit_id || row?.suite_id || "-"}</Tooltip>}>
            <div className="text-nowrap text-truncate pr-2">{row?.unit_id || row?.suite_id || "-"}</div>
        </OverlayTrigger>
    );

  showQuantityField = (row) => (
    <div className="text-nowrap text-truncate pr-2">{row?.quantity || 1}</div>
  );

  showProductField = (row) => (
    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-product`}>{row?.name || ""}</Tooltip>}>
      <div className="text-nowrap text-truncate pr-2">{row?.name || ""}</div>
    </OverlayTrigger>
  );

  componentDidMount = async () => {
    this.fetchTransactions();
    const height = tableHeightScrollBars();
    this.setState({ finalTableHeight: height, pendingFilterStatus: this.state.filterStatus });
  };

  fetchTransactions = async () => {
    this.setState({ loader: true });
    await this.props.getVtermTransactions();
    const { transactions } = this.props;
    this.setState({
      vtermTransactionsList: transactions || [],
      filteredTransactionsList: transactions || [],
      count: transactions ? transactions.length : 0,
      loader: false,
    });
  };
  // Apply filters only when Search is clicked, mimicking PermitTransaction.js
  applyFilters = () => {
    const { vtermTransactionsList, pendingFilterStatus, startDate, endDate, currentSummaryDate } = this.state;
    let filtered = vtermTransactionsList;

    // Specific date filter
    if (currentSummaryDate) {
      const target = new Date(currentSummaryDate);
      filtered = filtered.filter(row => {
        if (!row.transaction_time) return false;
        const txnDate = new Date(row.transaction_time);
        return txnDate.getFullYear() === target.getFullYear() &&
          txnDate.getMonth() === target.getMonth() &&
          txnDate.getDate() === target.getDate();
      });
    } else if (startDate && endDate) {
      // Date range filter
      const start = new Date(startDate);
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      filtered = filtered.filter(row => {
        if (!row.transaction_time) return false;
        const txnDate = new Date(row.transaction_time);
        return txnDate >= start && txnDate <= end;
      });
    }

    // Status filter
    if (pendingFilterStatus === "Paid") {
      filtered = filtered.filter(row => this.isApproved(row) && row.status !== "Refunded");
    } else if (pendingFilterStatus === "Failed") {
      filtered = filtered.filter(row => !this.isApproved(row) && row.status !== "Refunded");
    } else if (pendingFilterStatus === "Refunded") {
      filtered = filtered.filter(row => row.status === "Refunded");
    }

    this.setState({
      filterStatus: pendingFilterStatus,
      filteredTransactionsList: filtered,
      count: filtered.length,
    });
  };

  showTransactionIdField = (row) => (
    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.transaction_id}</Tooltip>}>
      <div className="text-nowrap text-truncate pr-2">{row?.transaction_id}</div>
    </OverlayTrigger>
  );

  showTransactionTime = (row) => (
    <>
      {row.transaction_time ? (
        <OverlayTrigger
          delay={{ show: 250, hide: 400 }}
          placement={"top"}
          overlay={<Tooltip id={`tooltip-qw`}>{utcToSpecificTimeZone(this.props.timezone, row.transaction_time, true)}</Tooltip>}
        >
          <div className="text-nowrap text-truncate pr-2">{utcToSpecificTimeZone(this.props.timezone, row.transaction_time, true)}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showAmountField = (row) => {
    if (row.amount) {
      const formattedAmount = parseFloat(row.amount).toFixed(2);
      return (
        <OverlayTrigger
          delay={{ show: 250, hide: 400 }}
          placement={"top"}
          overlay={<Tooltip id={`tooltip-qw`}>{row.status === "Refunded" ? `-${formattedAmount}` : formattedAmount}</Tooltip>}
        >
          <div className="text-nowrap text-truncate pr-2">{row.status === "Refunded" ? `-${formattedAmount}` : formattedAmount}</div>
        </OverlayTrigger>
      );
    } else {
      return "-";
    }
  };

  showCardNumberField = (row) => (
    <>
      {row?.card ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.card}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.card}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showTypeField = (row) => (
    <>
      {row?.type ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.type}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.type}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showMessageResponseField = (row) => (
    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.payment_status}</Tooltip>}>
      <div className="text-nowrap text-truncate pr-2">
        {row?.payment_status}
      </div>
    </OverlayTrigger>
  );

  getSuccessFailedData = (row) => {
    if (this.isApproved(row)) {
      return <div style={{ color: "green" }}>Approved</div>;
    }
    return <div style={{ color: "red" }}>Failed</div>;
  };

  getStatusData = (row) => {
    if (!this.isApproved(row)) {
      return <div>Failed</div>;
    }
    return (
      <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.status}</Tooltip>}>
        <div className="text-nowrap text-truncate pr-2">{row?.status}</div>
      </OverlayTrigger>
    );
  };

  dataTableHandle = (vtermTransactionsList) => {
    // Use filtered transactions for display
    const filtered = this.getFilteredTransactions();
    const data = this.state.searchValue.length ? this.state.searchedtransactionsList : filtered;
    return (
      <DataTable
        data={data}
        columns={this.columns}
        expandableRows={false}
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        onChangePage={scroolToTop}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={100}
        paginationTotalRows={data.length}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  handleSearchChange = async ({ target }) => {
    const val = target ? target.value.toString().trim() : this.state.searchValue.toString().trim();
    this.setState({ searchValue: val }, async () => {
      const columnList = ["transaction_time", "transaction_id", "name", "unit_id", "card", "amount", "status", "type", "payment_status"];
      const sourceList = this.getFilteredTransactions();
      if (this.state.searchValue.length) {
        this.setState(
          {
            searchedtransactionsList: findBySearch(
              this.state.searchValue,
              sourceList,
              sourceList,
              columnList,
              this.props.timezone,
            ),
          },
          () => {
            this.setState({ count: this.state.searchedtransactionsList.length });
          },
        );
      } else {
        this.setState({
          count: sourceList.length,
          searchedtransactionsList: [],
        });
      }
    });
  };

  handleCurrentDate = (date) => {
    this.setState({
      currentSummaryDate: date,
      startDate: null,
      endDate: null,
    });
  };

  handleChangeStartingDates = (date) => {
    const dt = new Date(date);
    const getEndDate = new Date(dt.setMonth(dt.getMonth() + 3));
    let selectEndDate;
    if (getEndDate > new Date()) {
      selectEndDate = new Date();
    } else {
      selectEndDate = getEndDate;
    }
    this.setState({
      startDate: date,
      endDate: selectEndDate,
      currentSummaryDate: null,
    });
  };

  handleChangeEndDates = (date) => {
    this.setState({
      endDate: date,
      currentSummaryDate: null,
    });
  };

  resetAll = () => {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - this.state.daysDifference);
    this.setState({
      filterStatus: "",
      pendingFilterStatus: "",
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      currentSummaryDate: null,
    });
  };

  handleExport = async () => {
    const { vtermTransactionsList, startDate, endDate, currentSummaryDate, filterStatus } = this.state;
    const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
    const exportDataName = `VTERM-TRANSACTIONS-${currentTimeDate}.xls`;
    if (vtermTransactionsList && vtermTransactionsList.length) {
      const pageobj = {
        exportData: true,
        timezone: this.props.timezone,
        filterStatus,
      };
      if (currentSummaryDate) {
        pageobj.currentSummaryDate = currentSummaryDate;
      }
      if (startDate && endDate) {
        pageobj.startDate = startDate;
        pageobj.endDate = endDate;
      }
      const bufferData = await this.props.getVtermTransactions(pageobj);
      if (bufferData) {
        saveAs(
          new Blob([bufferData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }),
          exportDataName,
        );
      }
    }
  };

  render() {
    const { vtermTransactionsList, loader, searchValue, startDate, endDate, currentSummaryDate, filterStatus, pendingFilterStatus, startDateTime, endDateTime } = this.state;
    const filteredTransactions = this.getFilteredTransactions();
    // All possible payment status options for dropdown
    const statusOptions = [
      { value: "", label: "Any" },
      { value: "Paid", label: "Paid (Approved)" },
      { value: "Failed", label: "Failed (not in Paid/Refunded)" },
      { value: "Refunded", label: "Refunded" },
    ];
    return (
      <div>
        <Card className="mb-0">
          <Card.Body className="pos-rel-overflow-hide">
            <>
              <div className="sidebarFilter">
                <Card className="contact-container mb-0">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Title as="h4">Virtual Terminal Transactions Report</Card.Title>
                      <a
                        onClick={() => document.body.classList.remove("foc-open")}
                        href="javascript:void(0);"
                        className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </a>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Form.Group controlId="filterStatus">
                      <Form.Label>Status:</Form.Label>
                      <Form.Control as="select" name="filterStatus" onChange={e => this.setState({ pendingFilterStatus: e.target.value })} value={pendingFilterStatus}>
                        <option value="">Any</option>
                        <option value="Paid">Paid</option>
                        <option value="Failed">Failed</option>
                        <option value="Refunded">Refunded</option>
                      </Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label className="mb-0 mr-2">Specific Date:</label>
                      <DatePicker
                        className="form-control"
                        placeholderText="Select Date"
                        selected={currentSummaryDate}
                        value={currentSummaryDate}
                        disabled={loader}
                        selectsStart
                        timeInputLabel="Time:"
                        onChange={date => this.handleCurrentDate(date)}
                        dateFormat="MM/dd/yyyy"
                      />
                    </Form.Group>
                    <Form.Group>
                      <label className="mb-0 mr-2">Start Date(Date Range):</label>
                      <DatePicker
                        className="form-control"
                        placeholderText="Select Start Date"
                        selected={startDate}
                        value={startDate}
                        disabled={loader}
                        selectsStart
                        timeInputLabel="Time:"
                        onChange={date => this.handleChangeStartingDates(date)}
                        dateFormat="MM/dd/yyyy"
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={new Date()}
                      />
                    </Form.Group>
                    <Form.Group>
                      <label className="mb-0 mr-2">End Date(Date Range):</label>
                      <DatePicker
                        className="form-control"
                        placeholderText="Select End Date"
                        selected={endDate}
                        disabled={loader}
                        value={endDate}
                        selectsEnd
                        timeInputLabel="Time:"
                        onChange={date => this.handleChangeEndDates(date)}
                        dateFormat="MM/dd/yyyy"
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        maxDate={new Date()}
                      />
                    </Form.Group>

                    <Card.Footer className="text-right justify-content-between d-flex">
                      <Button variant="info" className="h-40 custom-btn-secondary btn-sm" onClick={this.resetAll} disabled={loader}>
                        Reset
                      </Button>
                      <Button
                        variant="info"
                        className="h-40 btn-fill btn-sm ml-2"
                        onClick={this.applyFilters}
                        disabled={loader}
                      >
                        Search
                      </Button>
                    </Card.Footer>
                  </Card.Body>
                </Card>
              </div>
              <header>
                <div className="active-permit-header sm-flex-column sm-align-items-start">
                  <h5 className="mb-2 mb-md-0">Virtual Terminal Transactions</h5>
                  <div className="filter-button d-flex flex-wrap">
                    <div className="d-flex align-items-center search-mb-0">
                      <DatatableHeader
                        className="mt-0 mb-0"
                        searchValue={searchValue}
                        HandleChange={this.handleSearchChange}
                      />
                    </div>
                    <div className="ml-2">
                      <Button
                        variant="info"
                        className="btn-fill btn-sm"
                        onClick={this.handleExport}
                        disabled={vtermTransactionsList.length > 0 ? 0 : 1}
                        size="medium"
                      >
                        Export
                      </Button>
                    </div>
                  </div>
                </div>
              </header>
              {loader ? (
                <Loader />
              ) : (
                <>
                  {vtermTransactionsList && (
                    <>
                      <div className="citation-list-table has-parent-tab">{this.dataTableHandle(vtermTransactionsList)}</div>
                      <DateRangeAndAmount
                        ReportList={filteredTransactions}
                        amountName="amount"
                        startDateTime={startDateTime}
                        endDateTime={endDateTime}
                      />
                    </>
                  )}
                </>
              )}
            </>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { timezone } = state.UserProfileDetails;
  const { transactions } = state.VirtualTerminalDetails || {};
  return { timezone, transactions };
};

const mapDispatchToProps = {
  getVtermTransactions: VirtualTerminalActions.getTransactions,
};

export default connect(mapStateToProps, mapDispatchToProps)(VtermTransaction);
